import { render, staticRenderFns } from "./UpdatePrealert.vue?vue&type=template&id=23fb4b89"
import script from "./UpdatePrealert.vue?vue&type=script&lang=js"
export * from "./UpdatePrealert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports